var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricFact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211,
    height: 174,
    viewBox: "0 0 211 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5605 0.263672H163.675C172.671 0.263672 179.935 7.55865 179.935 16.5228V145.638C179.935 154.633 172.64 161.897 163.675 161.897H34.5605C25.5654 161.897 18.3014 154.602 18.3014 145.638V16.5537C18.2705 7.55866 25.5654 0.263672 34.5605 0.263672Z",
    fill: "#E7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4472 100.674H45.749V120.227H81.4472V100.674Z",
    fill: "#003852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.61 100.674H112.909V120.227H148.61V100.674Z",
    fill: "#003852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8834 112.716C42.0945 112.716 43.8882 110.925 43.8882 108.714C43.8882 106.503 42.0945 104.709 39.8834 104.709C37.6723 104.709 35.8813 106.503 35.8813 108.714C35.8813 110.925 37.6723 112.716 39.8834 112.716Z",
    fill: "#FFC930"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.582 112.716C168.793 112.716 170.586 110.925 170.586 108.714C170.586 106.503 168.793 104.709 166.582 104.709C164.371 104.709 162.58 106.503 162.58 108.714C162.58 110.925 164.371 112.716 166.582 112.716Z",
    fill: "#FFC930"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1097 120.227C38.5154 120.227 37.228 118.939 37.228 117.345C37.228 115.753 38.5154 114.463 40.1097 114.463H41.2732L45.2106 114.913L47.9469 116.381V116.392C47.7772 117.66 47.7665 118.939 47.9227 120.205V120.227H40.1097Z",
    fill: "#524F47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.697 120.227V120.205C144.853 118.939 144.842 117.66 144.686 116.392V116.37L155.65 114.463H167.705C169.296 114.463 170.586 115.753 170.586 117.345C170.586 118.939 169.296 120.227 167.705 120.227H144.697Z",
    fill: "#524F47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9273 120.227V120.205C78.0727 118.94 78.0727 117.66 77.9058 116.392V116.381L94.0945 109.083L114.714 116.381V116.405C114.547 117.671 114.547 118.95 114.703 120.216V120.238L77.9273 120.227Z",
    fill: "#524F47"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.686 116.416V116.392C143.8 109.61 138.441 104.251 131.657 103.365C130.994 103.276 130.334 103.23 129.672 103.23C122.115 103.23 115.678 108.88 114.703 116.381V116.405H77.9061V116.381C76.9958 109.667 71.6713 104.34 64.9438 103.432C64.2705 103.343 63.5864 103.297 62.9023 103.297C59.2827 103.297 55.76 104.609 53.0129 106.998C50.2336 109.408 48.4399 112.748 47.947 116.392V116.416H42.2052L42.1944 116.405C39.9079 112.322 39.0891 107.547 39.9079 102.939C40.8047 97.6336 43.3605 92.1072 47.1041 87.3753C51.4105 81.9269 57.2735 77.4967 64.0577 74.5719C65.819 73.8097 67.6908 73.4272 69.6191 73.4272H105.061C108.089 73.4272 110.96 74.6042 113.111 76.7237L126.96 90.3593L154.608 93.7554C157.188 94.0705 159.238 95.9989 159.709 98.5547L162.389 100.898C164.934 101.291 166.773 103.443 166.773 106.009V116.405L144.686 116.416Z",
    fill: "#61CCFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M166.751 112.694V106.02C166.751 105.584 166.695 105.158 166.595 104.733",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.692 104.733C39.4577 107.423 39.7728 110.125 40.6023 112.694",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0596 95.786L42.0703 95.751C45.2995 88.2828 51.2299 81.7033 58.787 77.2407H63.5862C63.9229 77.2407 64.2487 77.3619 64.4938 77.5881C65.0567 78.0918 65.0998 78.9563 64.5962 79.5165L52.6653 92.8585C50.9956 94.7195 48.6067 95.786 46.1074 95.786H42.0596Z",
    fill: "#524F47"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.54 95.786V77.2407H105.072C107.089 77.2407 108.996 78.0244 110.432 79.4491L124 92.6458C124.549 93.1736 124.705 93.9466 124.415 94.6414C124.132 95.347 123.483 95.786 122.721 95.786H96.54Z",
    fill: "#524F47"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.358 94.6737C124.266 94.461 124.132 94.2832 123.965 94.1243L110.399 80.9277C108.974 79.5165 107.078 78.7408 105.072 78.7408H96.54V77.2407H105.072C107.089 77.2407 108.996 78.0244 110.432 79.4491L124 92.6458C124.549 93.1736 124.705 93.9897 124.401 94.6872L124.38 94.7303L124.358 94.6737Z",
    fill: "#181818"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9544 95.786C63.6994 95.786 62.5898 95.0885 62.0296 93.9681C61.4802 92.8478 61.6014 91.5362 62.3635 90.537L69.9099 80.7149C71.5823 78.5415 74.227 77.2407 76.9741 77.2407H92.7723V95.786H64.9544Z",
    fill: "#524F47"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.7816 93.3056C61.5338 92.3549 61.76 91.3234 62.3633 90.537L69.9096 80.7149C71.5821 78.5415 74.2268 77.2407 76.9738 77.2407H92.7721V78.8539H76.9738C74.2376 78.8539 71.6144 80.144 69.9446 82.3201L62.3983 92.1395C62.129 92.4896 61.9378 92.8801 61.8273 93.3056H61.7816Z",
    fill: "#181818"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8309 101.167C70.0445 101.167 69.4062 100.529 69.4062 99.7426C69.4062 98.9589 70.0445 98.3179 70.8309 98.3179H74.8653C75.6518 98.3179 76.29 98.9589 76.29 99.7426C76.29 100.529 75.6518 101.167 74.8653 101.167H70.8309Z",
    fill: "#3C2C5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M69.619 100.483C69.4843 100.26 69.4062 100.001 69.4062 99.7426C69.4062 98.9589 70.0553 98.3179 70.8417 98.3179H74.8788C75.1481 98.3179 75.3932 98.3852 75.6167 98.5333C76.29 98.9481 76.492 99.8207 76.088 100.483L76.0665 100.516L76.045 100.483C75.7972 100.079 75.3474 99.8207 74.8653 99.8207H70.8309C70.3489 99.8207 69.8991 100.079 69.654 100.483L69.6298 100.505L69.619 100.483Z",
    fill: "#1C1C1C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.112 101.167C101.328 101.167 100.688 100.529 100.688 99.7426C100.688 98.9589 101.328 98.3179 102.112 98.3179H106.149C106.933 98.3179 107.571 98.9589 107.571 99.7426C107.571 100.529 106.933 101.167 106.149 101.167H102.112Z",
    fill: "#3C2C5B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.889 100.483C100.755 100.26 100.688 100.001 100.688 99.7426C100.688 98.9589 101.328 98.3179 102.112 98.3179H106.149C106.419 98.3179 106.664 98.3852 106.89 98.5333C107.561 98.9481 107.763 99.8207 107.359 100.483L107.337 100.516L107.315 100.483C107.068 100.079 106.621 99.8207 106.139 99.8207H102.101C101.619 99.8207 101.17 100.079 100.925 100.483L100.9 100.505L100.889 100.483Z",
    fill: "#1C1C1C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.95 108.568C157.164 108.568 156.525 107.927 156.525 107.143C156.525 106.357 157.164 105.719 157.95 105.719H160.191C160.977 105.719 161.616 106.357 161.616 107.143C161.616 107.927 160.977 108.568 160.191 108.568H157.95Z",
    fill: "#003852"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.95 107.558C157.164 107.558 156.525 106.92 156.525 106.134C156.525 105.35 157.164 104.709 157.95 104.709H160.191C160.977 104.709 161.616 105.35 161.616 106.134C161.616 106.92 160.977 107.558 160.191 107.558H157.95Z",
    fill: "#FFC930"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9265 130.208C69.4387 130.208 74.72 124.927 74.72 118.412C74.72 111.897 69.4387 106.616 62.9265 106.616C56.4117 106.616 51.1304 111.897 51.1304 118.412C51.1304 124.927 56.4117 130.208 62.9265 130.208Z",
    fill: "#3C2C5B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9262 121.91C64.8572 121.91 66.4246 120.343 66.4246 118.412C66.4246 116.478 64.8572 114.913 62.9262 114.913C60.9925 114.913 59.4277 116.478 59.4277 118.412C59.4277 120.343 60.9925 121.91 62.9262 121.91Z",
    fill: "#1C1C1C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7591 100.696C58.4315 100.696 59.7862 99.3412 59.7862 97.6687C59.7862 95.9963 58.4315 94.6416 56.7591 94.6416C55.0866 94.6416 53.7319 95.9963 53.7319 97.6687C53.7319 99.3412 55.0866 100.696 56.7591 100.696Z",
    fill: "#3C2C5B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M138.034 126.693C142.639 122.088 142.639 114.619 138.034 110.014C133.426 105.406 125.958 105.406 121.352 110.014C116.747 114.619 116.747 122.088 121.352 126.693C125.958 131.301 133.426 131.301 138.034 126.693Z",
    fill: "#3C2C5B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.693 121.853C131.627 121.853 133.191 120.286 133.191 118.355C133.191 116.424 131.627 114.856 129.693 114.856C127.762 114.856 126.197 116.424 126.197 118.355C126.197 120.286 127.762 121.853 129.693 121.853Z",
    fill: "#1C1C1C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6548 77.4858V116.392",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9497 116.392H47.9008",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8384 116.392H114.727",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.662 116.392H167.648",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7505 77.2622H96.5613",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7236 99.4624H44.0874",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.0252 80.1224C64.0009 79.4141 63.4192 78.8539 62.7001 78.8539H56.2661L56.3227 78.8082C57.1064 78.2722 57.9359 77.7443 58.7869 77.2407H63.5862C63.9228 77.2407 64.2487 77.3619 64.4965 77.5881C65.0567 78.0918 65.0998 78.9563 64.5961 79.5165L64.001 80.1763L64.0252 80.1224Z",
    fill: "#181818"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M139.728 98.5654L162.378 100.919",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M159.598 98.2746L158.947 97.7252C158.039 96.9523 156.919 96.4567 155.742 96.2897L154.137 96.0527",
    stroke: "#003852",
    strokeWidth: 1.07728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.617 15.3481H203.965C207.764 15.3481 210.831 18.43 210.831 22.2141V66.5615C210.831 70.3608 207.751 73.4274 203.965 73.4274H159.617C155.82 73.4274 152.751 70.3477 152.751 66.5615V22.2141C152.751 18.43 155.833 15.3481 159.617 15.3481Z",
    fill: "#4FA6D0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M194.63 41.4211H185.968C185.116 41.4211 184.434 40.7391 184.434 39.8867C184.434 39.7162 184.468 39.5112 184.536 39.3407L188.697 28.088C189.003 27.3039 188.594 26.4177 187.776 26.1105C187.196 25.9062 186.583 26.0422 186.139 26.4515L167.862 44.7286C167.248 45.3422 167.248 46.2975 167.862 46.9111C168.135 47.1838 168.544 47.3543 168.953 47.3543H177.614C178.467 47.3543 179.149 48.0362 179.149 48.8886C179.149 49.0591 179.114 49.2641 179.047 49.4346L174.886 60.6874C174.58 61.4714 174.989 62.3577 175.807 62.6648C176.387 62.8699 177 62.7332 177.444 62.3239L195.721 44.0467C196.335 43.4331 196.335 42.4778 195.721 41.8642C195.414 41.5916 195.039 41.4211 194.63 41.4211Z",
    fill: "#61CCFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3013 40.3629C24.6958 36.74 31.7497 31.0922 37.0561 36.74C40.2544 40.1496 40.4677 48.0356 49.4184 46.1174C58.3692 44.1992 70.0915 32.6903 80.1089 34.1818C91.1485 35.8226 89.0616 56.9863 79.8956 61.8893C69.9848 67.1958 68.1733 46.5441 96.5209 45.0526",
    stroke: "#3C2C5B",
    strokeWidth: 0.775796,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.913 38.8716H109.734V51.2319H102.913C101.274 51.2319 99.7032 50.5803 98.5454 49.4205C97.3855 48.2626 96.7339 46.6916 96.7339 45.0527C96.7339 43.4139 97.3855 41.8409 98.5454 40.6831C99.7032 39.5232 101.274 38.8716 102.913 38.8716Z",
    fill: "#3C2C5B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.095 42.7075H114.422",
    stroke: "#3C2C5B",
    strokeWidth: 0.775796,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.095 47.3955H114.422",
    stroke: "#3C2C5B",
    strokeWidth: 0.775796,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.734 38.0186V52.0857",
    stroke: "#3C2C5B",
    strokeWidth: 0.775796,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9246 166.079C50.2876 156.72 50.2876 141.539 40.9246 132.179C31.5648 122.816 16.3845 122.816 7.02463 132.179C-2.33829 141.539 -2.33829 156.72 7.02463 166.079C16.3845 175.442 31.5648 175.442 40.9246 166.079Z",
    fill: "#FFC943"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0688 134.664V139.075",
    stroke: "#524F47",
    strokeWidth: 1.23644,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0688 159.196V163.607",
    stroke: "#524F47",
    strokeWidth: 1.23644,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6317 139.168H22.1744C19.6583 139.168 17.6089 141.218 17.6089 143.734C17.6089 145.752 18.9442 147.521 20.87 148.111L26.9563 149.913C28.9748 150.503 30.3411 152.364 30.3411 154.445C30.3411 157.054 28.2299 159.165 25.621 159.165H18.6969",
    stroke: "#524F47",
    strokeWidth: 1.23644,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricFact);
export default __webpack_public_path__ + "static/media/electric-fact.36014d396f935b00cb9289a10fd0562b.svg";
export { ForwardRef as ReactComponent };